import { defineTranslation } from './define';

export const ja = defineTranslation({
  "state.unavailableBody": "このチェックアウトは一時的にご利用いただけません。しばらくしてからもう一度お試しください。",
  "action.accessExpired": "このアクセスは期限切れか利用できません。続行するには新しいリンクをリクエストしてください。",
  "action.requestLink": "新しいリンクを送信",
  "action.linkSent": "このアクセスが有効な場合、登録されたメールアドレスに新しいリンクを送信します。",
  "action.accessProcessing": "お支払いは処理中の可能性があります。新しいリンクで状況を確認してください。再度支払わないでください。",

  "error.priceChangedTitle": "情報が古くなっています",
  "block.PRECO_ALTERADO": "この購入情報は古くなっています。ページを更新し、金額を確認してから続行してください。",
  "error.refresh": "ページを更新",
  "error.priceRefreshed": "為替レートが更新されました。価格を確認し、もう一度確定してください。",
  "summary.loading": "注文概要を読み込み中",
  "summary.unavailableTitle": "注文概要を表示できません",
  "summary.unavailableBody": "詳細を読み込めませんでした。購入確認メールをご確認ください。",
  "summary.mainPurchase": "メインの購入",
  "summary.additionalOffer": "追加オファー",
  "upsell.protectedOffer": "保護されたオファー",
  "upsell.storageTitle": "オファーを表示するには確認してください",
  "upsell.storageDeniedTitle": "このブラウザーではオファーを表示できません",
  "upsell.storageBody": "ブラウザーはサイト間のデータを保護しています。VendePay がこのオファーを安全に読み込めるように許可してください。",
  "upsell.storageDeniedBody": "ブラウザーがこのサイトでのアクセスを許可しませんでした。VendePay でオファーを安全に開くか、オファーなしで続行してください。",
  "upsell.loading": "読み込み中…",
  "upsell.loadOffer": "オファーを読み込む",
  "upsell.openHosted": "VendePay でオファーを開く",
  "error.retry": "もう一度試す",
  "error.systemTitle": "問題が発生しました",
  "error.validationTitle": "入力情報をご確認ください",
  "error.paymentTitle": "支払いが完了していません",
  "action.processingTitle": "支払い処理中",
  "action.canceledTitle": "解約を申請しました",
  "action.alreadyCanceledTitle": "サブスクリプションは解約済みです",
  "action.cardUpdatedTitle": "カードを更新しました",
  "action.paidTitle": "支払いを処理しました",
  "action.cancelTitle": "サブスクリプションを解約",
  "action.cardTitle": "カードを変更",
  "action.payTitle": "請求書を支払う",
  "action.loading": "リンクを読み込み中…",
  "action.canceledBody": "サブスクリプションは現在の期間の終了時に終了します。",
  "action.alreadyCanceledBody": "再度解約を申請する必要はありません。",
  "action.cardUpdatedBody": "サブスクリプションのカードを更新しました。このページを閉じても構いません。",
  "action.paidBody": "請求書を更新しました。このページを閉じても構いません。",
  "action.processingBody": "請求が確認され、決済事業者による精算を待っています。再度支払わないでください。",
  "action.plan": "プラン",
  "action.status": "ステータス",
  "action.invoice": "請求書",
  "action.period": "現在の期間",
  "action.until": "{{date}} まで",
  "action.authentication": "銀行からカードのセキュリティ確認が求められています。",
  "action.cancelButton": "期間終了時に解約",
  "action.saveButton": "カードを保存",
  "action.authenticateButton": "カードを認証",
  "action.payButton": "今すぐ支払う",
  "action.trialing": "試用中",
  "action.active": "有効",
  "action.pastDue": "支払い遅延",
  "action.canceled": "解約済み",
  "action.pending": "保留中",
  "action.processing": "処理中",
  "action.awaitingAction": "操作が必要",
  "action.paid": "支払い済み",
  "action.inGrace": "猶予期間中",
  "action.failed": "失敗",
  'language.select': '言語', 'common.demo': 'デモ', 'common.emailFallback': 'メールアドレス',
  'common.processing': '処理中…', 'common.free': '無料', 'common.today': '本日', 'common.total': '合計',
  'common.unavailable': '利用できません', 'common.onRequest': 'お問い合わせ',
  'period.minute.one': '分', 'period.minute.other': '分',
  'period.day.one': '日', 'period.day.other': '日', 'period.week.one': '週間', 'period.week.other': '週間',
  'period.month.one': 'か月', 'period.month.other': 'か月', 'period.year.one': '年', 'period.year.other': '年',
  'period.single': '/{{unit}}', 'period.every': ' {{count}}{{unit}}ごと', 'period.for': '{{unit}}ごと',
  'field.name': '氏名', 'field.namePlaceholder': '本人確認書類と同じ表記', 'field.email': 'メールアドレス',
  'field.emailPlaceholder': 'you@email.com', 'field.phone': '電話 / WhatsApp',
  'field.internationalPhone': '国際電話番号（任意）', 'field.internationalPhonePlaceholder': '+ 国番号と電話番号',
  'field.document': '本人確認書類', 'field.documentPlaceholder': '書類番号',
  'pii.email': 'メールアドレス', 'pii.phone': '電話番号', 'pii.emailPhone': 'メールアドレスと電話番号',
  'pii.optional': '任意: 購入には影響しません',
  'pii.consent': 'この購入の広告コンバージョン測定のため、ハッシュで保護した{{target}}の使用を許可します。',
  'state.loading': 'チェックアウトを読み込んでいます…', 'state.notFoundTitle': 'チェックアウトを利用できません',
  'state.notFoundBody': 'このチェックアウトは存在しないか、無効になっています。', 'state.errorTitle': 'エラーが発生しました',
  'state.errorBody': '現在チェックアウトを読み込めません。しばらくしてからもう一度お試しください。',
  'error.payment': '支払いを完了できませんでした。', 'error.cardDetails': 'カード情報を確認してください。',
  'error.checkoutUnavailable': 'このチェックアウトは現在利用できません。', 'error.subscriptionCardOnly': 'サブスクリプションはカードでのみ支払えます。',
  'error.emailWalletRequired': 'ウォレットを利用するにはメールアドレスを入力してください。',
  'error.emailWalletInvalid': 'ウォレットを利用するには有効なメールアドレスを入力してください。',
  'error.emailRequired': '購入を完了するにはメールアドレスを入力してください。',
  'error.emailInvalid': '購入を完了するには有効なメールアドレスを入力してください。',
  'error.confirmationExpired': '確認の有効期限が切れました。もう一度お試しください。',
  'error.authentication': 'カード認証を完了できませんでした。', 'error.offerUnavailable': 'このオファーは現在利用できません。',
  'error.offerProcessing': 'オファーを処理できませんでした。',
  'decline.currency_not_supported': 'このカードは今回の購入で使用する通貨に対応していません。別のカードまたは支払い方法をお試しください。',
  'decline.card_not_supported': 'このカードはこの種類の購入に対応していません。別のカードを使用するか、銀行にお問い合わせください。',
  'decline.incorrect_address': '請求先住所が正しくありません。内容を確認して、もう一度お試しください。',
  'decline.incorrect_zip': '請求先住所の郵便番号が正しくありません。内容を確認して、もう一度お試しください。',
  'decline.invalid_expiry': 'カードの有効期限が正しくありません。月と年を確認して、もう一度お試しください。',
  'decline.invalid_account': 'このカードはお支払いに使用できません。別のカードを使用するか、銀行にお問い合わせください。',
  'decline.invalid_amount': 'このカードではこの金額をお支払いいただけません。別のカードを使用するか、銀行にお問い合わせください。',
  'decline.duplicate_transaction': '同じ内容の購入が最近送信されています。再試行する前に、支払いがすでに確定しているか確認してください。',
  'decline.contact_issuer': 'この購入を承認できませんでした。別のカードを使用するか、銀行にお問い合わせください。',
  'decline.testmode_decline': 'このテストカードは今回の購入には使用できません。別のカードを使用してください。',
  'decline.authentication_failure': 'カード認証を完了できませんでした。もう一度試して、認証手続きを完了してください。',
  'decline.card_decline_rate_limit_exceeded': 'このカードでの支払いが何度も拒否されています。24時間待つか、別のカードを使用してください。',
  'decline.card_velocity_exceeded': 'このカードは残高、利用可能枠、または1回あたりの購入金額の上限に達しました。別のカードを使用するか、銀行にお問い合わせください。',
  'decline.insufficient_funds': '残高が不足しています。別のカードまたは支払い方法をお試しください。',
  'decline.expired_card': 'このカードは有効期限が切れています。有効期限を確認するか、別のカードをお試しください。',
  'decline.incorrect_cvc': 'カードのセキュリティコードが正しくありません。CVCを確認して、もう一度お試しください。',
  'decline.invalid_cvc': 'カードのセキュリティコードが無効です。CVCを確認して、もう一度お試しください。',
  'decline.incorrect_number': 'カード番号が正しくありません。入力内容を確認して、もう一度お試しください。',
  'decline.invalid_number': 'カード番号が無効です。入力内容を確認して、もう一度お試しください。',
  'decline.authentication_required': '銀行がこの購入の認証を求めています。もう一度試して認証を完了してください。',
  'decline.processing_error': '現在カードを処理できません。しばらくしてからもう一度お試しください。',
  'decline.issuer_not_available': 'カード発行会社は現在利用できません。しばらくしてから再試行するか、別のカードをお試しください。',
  'decline.try_again_later': '銀行から時間をおいて再試行するよう求められています。少し待つか、別のカードをお試しください。',
  'decline.subscriptionContext': 'サブスクリプションを確認できませんでした。 {{message}}',
  'decline.default': '支払いを完了できませんでした。別のカードまたは支払い方法をお試しください。',
  'payment.card': 'カード', 'payment.creditCard': 'クレジットカード', 'payment.boleto': '支払票', 'payment.method': '支払い方法',
  'payment.express': 'かんたん決済', 'payment.otherMethods': 'その他の支払い方法',
  'payment.recurring': '継続課金', 'payment.upfront': '一括', 'payment.instant': '即時', 'payment.approved': '支払い済み',
  'payment.pending': '確認待ち', 'payment.awaitingPix': 'Pix の確認待ち', 'payment.requiresAction': '認証待ち', 'payment.notConfirmed': '未確認',
  'payment.firstChargePaid': '初回支払い済み', 'payment.freeTrialStarted': '無料トライアル開始',
  'payment.cardEnding': '{{brand}} 下4桁 {{last4}}', 'payment.processingWallet': '{{wallet}} で支払いを処理しています…',
  'payment.completeWallet': '{{wallet}} で支払いを完了してください',
  'payment.walletHelp': '開いている安全なウィンドウを使用してください。キャンセルするとカード入力欄が自動的に戻ります。',
  'payment.or': 'または', 'payment.secureConnection': '支払いデータは TLS 接続で保護されています',
  'payment.cardNumber': 'カード番号', 'payment.cardholderName': 'カード名義', 'payment.cardholderPlaceholder': 'カードの表記どおり',
  'payment.expiry': '有効期限', 'payment.cvv': 'CVV', 'payment.walletReceipt': '確認と領収書は {{email}} に送信されます。',
  'payment.processedBy': '支払いは VendePay と決済事業者が処理します。データはプライバシーポリシーに従って取り扱われます。',
  'checkout.securePurchase': '安全な購入', 'checkout.choosePlan': 'プランを選択', 'checkout.bestValue': 'おすすめ',
  'checkout.yourDetails': 'お客様情報', 'checkout.guest': 'アカウントを作成せずに購入できます: パスワードは後で設定できます。',
  'checkout.payment': '支払い', 'checkout.completeOrder': 'ご注文を完成させる', 'checkout.orderSummary': '注文内容', 'checkout.reviewSummary': '購入内容',
  'checkout.chargedNow': '今回の請求', 'checkout.totalChargedNow': '今回の請求合計',
  'checkout.awaitingConfirmation': '確認待ち', 'checkout.recurringCharges': '継続課金',
  'checkout.nextCharges': '次回以降の請求', 'checkout.subscriptionActive': 'サブスクリプションは有効です。解約リンクはメールに記載されています。',
  'checkout.renewsFor': '{{value}} で自動更新', 'checkout.subscribeFor': '{{value}} で登録',
  'checkout.payAndFinish': '{{value}} を支払って購入を完了', 'checkout.startTrial': '{{days}}日間の無料トライアルを開始',
  'checkout.startFree': '無料で開始', 'checkout.subscribeNow': '今すぐ登録', 'checkout.payNow': '今すぐ支払う',
  'checkout.finishWallet': '{{wallet}} で完了', 'checkout.productDelivery': '商品は販売者から提供されます。',
  'checkout.confirmationSent': '{{email}} に確認を送信しました。{{delivery}}',
  'checkout.guarantee': '{{days}}日間保証', 'checkout.fullRefundGuarantee': '{{days}}日間保証: 全額返金',
  'checkout.secureEncrypted': '安全な支払い · 暗号化データ', 'checkout.dataProtected': 'データ保護済み',
  'checkout.cardNotStored': 'カード情報は保存しません',
  'coupon.percentDiscount': '割引率',
  'coupon.fixedDiscount': '定額割引',
  "coupon.appliesToProduct": "割引は{{product}}にのみ適用されます。",
  "summary.purchaseItems": "今回購入した商品",
  "summary.purchaseTotal": "今回の購入合計",
  'coupon.beforeDiscount': 'クーポン適用前の金額',
  'coupon.discountAmount': '適用された割引',
  'coupon.afterDiscount': 'クーポン適用後の金額',
  'coupon.label': 'クーポン {{code}}', 'coupon.applied': 'クーポン 適用済み', 'coupon.remove': '削除',
  'coupon.code': 'クーポンコード', 'coupon.validating': '確認中…', 'coupon.apply': '適用', 'coupon.haveOne': 'クーポンをお持ちですか？',
  'coupon.invalid': 'クーポンが無効または期限切れです。', 'summary.trialPeriod': 'トライアル期間', 'summary.days': '{{days}}日',
  'summary.totalToday': '本日の合計', 'summary.recurringCharge': '継続課金',
  'pending.subscriptionTitle': 'サブスクリプションを確認しています',
  'pending.subscriptionBody': '認証が完了しました。無料期間を有効化し、{{email}} に確認を送信します。',
  'pending.authenticationTitle': '認証が必要です',
  'pending.authenticationBody': '銀行から追加確認が求められました。支払いを完了するには認証を完了してください。',
  'success.added': '追加しました！', 'success.addedBody': 'カードに +{{value}} を請求しました。',
  'success.subscriptionTitle': 'サブスクリプションを開始しました！', 'success.freeDays': '{{days}}日間無料です。本日の請求はありません。',
  'success.firstCharge': ' {{value}} の初回請求日は {{date}} です。',
  'success.subscriptionEmail': '確認と解約リンクを {{email}} に送信しました。', 'success.paymentTitle': '支払いが承認されました！',
  'subscription.single': 'サブスクリプション', 'subscription.oneTime': '一回限りの購入',
  'subscription.bumpTerms': 'カードのサブスクリプション：自動更新。メールのリンクから解約できます。',
  'subscription.afterPaidTrialTerms': '最初の {{days}} 日間の後、自動更新されます：',
  'subscription.freeTerms': '{{days}}日間無料、本日の請求なし。その後 ',
  'subscription.renewalTerms': '自動更新：', 'subscription.cancelTerms': '。期間終了時にメールのリンクから解約できます。',
  'upsell.downsellBadge': 'お待ちください！特別オファー', 'upsell.badge': '期間限定の特別オファー',
  'upsell.addCard': 'はい、カードに +{{value}} を追加', 'upsell.continueWithout': 'このオファーなしで続行',
  'upsell.reassurance': '支払い承認済み: 完了前の特別オファー', 'upsell.trialDays': '{{days}}日間トライアル',
  'upsell.oneClick': '安全なワンクリック購入', 'upsell.noCardAgain': 'カードの再入力は不要です',
  'legacy.urgency': '期間限定オファー', 'legacy.reassurance': '保護された購入 · 支払い後すぐにアクセス',
  'upsell.accept': 'はい、購入します', 'upsell.reject': 'いいえ、結構です',
  'installment.label': '{{count}}回払い（1回 {{value}}）',
});
